export default __webpack_public_path__ + "static/iphone-04-c22a4462cd8470c925200ee457bfce58.png";